module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    staticClass: "fi-footer"
  }, [_c('ul', {
    staticClass: "clearfix"
  }, [_c('li', [_c('h2', [_vm._v("关于我们")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "/aboutus"
    }
  }, [_vm._v("关于点点")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "/aboutus"
    }
  }, [_vm._v("点点大事记")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "/aboutus"
    }
  }, [_vm._v("点点愿景")])]), _vm._v(" "), _c('li', [_c('h2', [_vm._v("帮助")]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": "/helpcenter"
    }
  }, [_vm._v("帮助中心")])]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": "https://im2.zhongan.io/zaim/?accessId=1597999116941&tenantID=1514946886000043&color=yellow&themeID=DD001&channelId=94&subject=点点业务&biz=手网"
    }
  }, [_vm._v("在线咨询")])]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": "/helpcenter"
    }
  }, [_vm._v("意见反馈")])])]), _vm._v(" "), _c('li', [_c('h2', [_vm._v("客户服务")]), _vm._v(" "), _c('p', [_vm._v("客服热线：4000666122")]), _vm._v(" "), _c('p', [_vm._v("工作日9:00-18:00")])]), _vm._v(" "), _c('li')]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "footer-text"
  }, [_vm._v("Copyright © 169 2017 - 2018 Diandian 点点版权所有 "), _c('a', {
    attrs: {
      "href": "https://beian.miit.gov.cn"
    }
  }, [_vm._v("粤ICP备17079095号")]), _vm._v(" 深圳众联商务有限公司")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1ca45c07"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/footer/index.vue
// module id = 333
// module chunks = 1